<div class="container">
  <div class="heading_align">
    <div class="heading">Términos y condiciones de uso <span class="font_14 font_normal"> de Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>ENTRADA EN VIGOR: 25/04/2023</b></div>
        <div class="eula_points">
          Las siguientes Condiciones de uso de Synappx™, así como la <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Política de privacidad de Synappx</b></a> incorporada en el
          presente documento a modo de referencia (en conjunto, el «Contrato»), se conciertan entre Sharp Corporation
          («Sharp») y el Cliente. Este Contrato rige el acceso a Synappx y su uso, así como cualquier Servicio
          accesible a través de Synappx. A los efectos del presente Contrato, el término «Synappx» hará referencia a
          Synappx Go, Synappx Admin Portal y a la Documentación relacionada; el término
          «Servicio» hará referencia a los Servicios de Synappx, a los Servicios de software específicos y a toda la
          Documentación que pueda ser propiedad de Sharp o de proveedores de servicios externos («Proveedores de
          servicios externos») y que resulte accesible a través del Servicio de Synappx.
        </div>
      </div>
    }
    @if (showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>ENTRADA EN VIGOR: 11 de julio de 2023</b></div>
        <div class="eula_points">
          Las siguientes Condiciones de uso de Synappx™, así como la <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Política de privacidad de Synappx</b></a> incorporada en el
          presente documento a modo de referencia (en conjunto, el «Contrato»), se conciertan entre Sharp Corporation
          («Sharp») y el Cliente. Este Contrato rige el acceso a Synappx y su uso, así como cualquier Servicio
          accesible a través de Synappx. A los efectos del presente Contrato, el término «Synappx» hará referencia a
          Synappx Go, Synappx Cloud Print, Synappx Admin Portal y a la Documentación relacionada; el término
          «Servicio» hará referencia a los Servicios de Synappx, a los Servicios de software específicos y a toda la
          Documentación que pueda ser propiedad de Sharp o de proveedores de servicios externos («Proveedores de
          servicios externos») y que resulte accesible a través del Servicio de Synappx.
        </div>
      </div>
    }
    <div class="eula_points">
      El uso de estos Servicios se ha previsto para organizaciones («Cliente») y sus Usuarios finales. Los
      términos «Usuario final» o «Usuarios finales» y sus variaciones harán referencia a cualquier persona que
      acceda a los servicios prestados por el Servicio de Synappx y puede incluir, entre otros, a empleados,
      representantes, contratistas, agentes o cualquier otra persona del Cliente que acceda a los Servicios desde
      una Cuenta del cliente o que los use, y que esté autorizada por el Cliente para usar los Servicios. Todas
      las referencias al término «Cliente» también harán referencia al Administrador o los Administradores del
      Cliente y a cualquier de sus Usuarios finales, ya sea de manera individual o colectiva.
    </div>
    <div class="eula_points">
      Con anterioridad a cualquier uso y antes de que se conceda acceso al Cliente, el Administrador o los
      Administradores autorizados del Cliente deberán aceptar este Contrato en nombre del Cliente. Al hacer clic
      en «Acepto», el Administrador declara y garantiza: 1) que ha sido designado por el Cliente como un
      «Administrador» y que tiene todos los derechos y privilegios otorgados a todas aquellas personas con la
      función de Administrador (como se describe en más detalle más adelante); 2) que tiene la autoridad para
      vincular al Cliente al presente Contrato. Si el Usuario no ha sido nombrado Administrador del Cliente o no
      tiene la autoridad indicada arriba, no podrá hacer clic en «Acepto» y el Cliente no podrá acceder a los
      Servicios ni usarlos. Al hacer clic en «Acepto», el Cliente tendrá el derecho de acceder a los Servicios y
      de usarlos con sujeción a las condiciones establecidas en el presente documento.
    </div>
    <div class="eula_points">
      Pueden existir otros servicios de software específicos («Servicios de software específicos») accesibles
      dentro de los Servicios del administrador de Synappx o a través de estos, que permiten al Cliente llevar a
      cabo determinadas funciones o utilizar servicios y funciones adicionales; estos Servicios de software
      específicos son propiedad de Sharp o de los Proveedores de servicios externos. El Cliente entiende que el
      acceso a estos Servicios de software específicos o el uso de ellos puede requerir que el Cliente, el
      Administrador o los Administradores, o los Usuarios finales acepten términos y condiciones adicionales
      aplicables para acceder a ellos o usarlos («Condiciones adicionales»). Si el Cliente, el Administrador o los
      Administradores, o los Usuarios finales no aceptan dichas Condiciones adicionales o no tienen autoridad para
      aceptarlas, el Cliente, el Administrador o los Administradores, o los Usuarios finales, según corresponda,
      no podrán acceder a dichos Servicios de software específicos ni usarlos. Si se produce alguna discrepancia
      entre este Contrato y las Condiciones adicionales, las Condiciones adicionales prevalecerán, pero solo para
      el Servicio de software específico.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definiciones</b> <br />
        Además de los términos definidos más arriba, se aplican las siguientes definiciones a este Contrato:
        <ol>
          <li> <b>Cuenta del cliente:</b> Se refiere a todas las cuentas de un
          Cliente o asignadas a este. En esta definición se incluyen todas las Cuentas de administrador
          aplicables y cualquier Servicio con licencia concedida al Cliente, al Administrador o
          Administradores y a sus Usuarios finales, así como a la información y datos asociados a estos.
        </li>
        <li> <b>Administrador:</b> El empleado o empleados designados por el
        Cliente para gestionar la información y los datos asociados a la Cuenta del cliente, así como el
      acceso a los Servicios y las licencias vinculadas en nombre del Cliente.</li>
      <li> <b> Cuenta del administrador:</b> Esto se refiere a la cuenta del
    administrador:</li>
    <li> <b>Datos del cliente:</b> Cualquier información almacenada,
    transmitida o tratada, o a la que se haya accedido a través de los Servicios por parte del
    Cliente, el Administrador o los Administradores y sus Usuarios finales o que estén asociados a
  una Cuenta del cliente.</li>
  <li> <b>Distribuidor:</b> El establecimiento autorizado para la
  distribución de los Servicios al Cliente. El Distribuidor puede ser Sharp, su subsidiaria o las
  sucursales del distribuidor directo de la subsidiaria (en caso de venta directa a un Cliente) o
  un establecimiento comercial externo autorizado para vender productos o servicios de Sharp. El
  Distribuidor es también el contacto principal del Cliente para cuestiones de asistencia
  relacionadas con los Servicios. El distribuidor puede proporcionar servicios al Cliente de
  conformidad con un Contrato con el Cliente y/o el
Administrador.</li>
<li> <b>Documentación:</b> Todas y cada una de las guías de instalación y
uso, archivos de ayuda y preguntas frecuentes relacionadas con el acceso a los Servicios o el
uso de estos.</li>
<li> <b>Derechos de propiedad intelectual:</b> Cualquier derecho global
actual o futuro en virtud de una patente, derecho de autor, secreto comercial, marca comercial,
derechos morales y otros derechos de propiedad intelectual.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Uso y responsabilidades del Cliente </b>
  <ol>
    <li> El Cliente es responsable de designar a la persona o las personas autorizadas para adoptar la
      función de Administrador en nombre del Cliente. El Cliente puede asignar y reasignar las Cuentas
    de administrador.</li>
    <li> El Cliente es responsable de gestionar el acceso a las Cuentas de administrador y de que el
      acceso a los Servicios por parte del Cliente, el Administrador o los Administradores y los
      Usuarios finales o su uso de estos cumple este Contrato, las Condiciones adicionales y cualquier
      Documentación aplicable. Sharp y el Distribuidor no serán responsables de la gestión, la
    administración o el uso internos de los Servicios en nombre del Cliente.</li>
    <li> El Cliente entiende y acepta que su Administrador o sus Administradores y los Usuarios finales
      se regirán por este Contrato, las Condiciones adicionales, la Documentación y cualquier ley,
      reglamentos y normativas relacionadas con el uso de los Servicios, y que deberán cumplirlos. El
      Cliente será el único responsable de todos los actos y todas las omisiones del Cliente, su
      Administrador o sus Administradores y los Usuarios finales o del incumplimiento de las
      condiciones de este Contrato, las Condiciones adicionales, la Documentación y cualquier ley,
      reglamentos y normativas relacionadas con el uso de los Servicios. Esta responsabilidad se
      extiende a todas las actividades asociadas a una Cuenta del cliente, con independencia de si las
      actividades son realizadas por el Cliente, sus empleados o un tercero (incluidos, entre otros,
    los contratistas, representantes o agentes del Cliente).</li>
    <li> El Cliente es responsable de asegurarse de que el Administrador o los Administradores y los
      Usuarios Finales cumplen todas las obligaciones de empleo aplicables, así como las condiciones y
    políticas del Cliente en relación con el acceso a los Servicios y el uso de estos.</li>
    <li> El Cliente acepta recabar y mantener todos los consentimientos aplicables de los Usuarios
      finales para permitir a los Administradores participar en todas las actividades que se describen
      en este Contrato, así como para permitir que Sharp o a los Proveedores de servicios externos
    presten los Servicios.</li>
    <li> El Cliente es responsable de los accesos no autorizados a los Servicios o el uso de estos por
      parte del Cliente, el Administrador o los Administradores y los Usuarios finales, así como de
      cualquier tercero, y deberá impedirlos. El Cliente informará inmediatamente a Sharp y al
      Distribuidor de cualquier acceso no autorizado a los Servicios o de cualquier uso no autorizado
      de estos. Sharp y el Distribuidor no serán responsables de los accesos no autorizados a las
    Cuentas del cliente o de los usos no autorizados de estas.</li>
    <li> El Cliente utilizará únicamente los Servicios para sus operaciones empresariales internas y no
      para la operación de una agencia de servicios o un servicio en régimen de tiempo compartido. El
      Cliente no utilizará ni permitirá utilizar, de forma consciente y deliberada, los Servicios de
      forman que puedan dañar, deshabilitar, sobrecargar, perturbar o interferir de otro modo con su
      aprovisionamiento, incluidos, entre otros, el uso de los Servicios para transmitir virus o dañar
      archivos que puedan comprometer la integridad y la seguridad de los Servicios de cualquier
    forma.</li>
    <li> El Cliente se asegurará de que su Administrador o sus Administradores, o Usuarios finales, de
      forma directa o indirecta: (a) no aplican ingeniería inversa, descompilan, desensamblan ni
      intentan de otra forma descubrir el código fuente, el código objeto o la estructura, ideas o
      algoritmos subyacentes de los Servicios ni de ningún otro software, Documentación o datos
      relacionados o suministrados con los Servicios o a través de estos; (b) no modifican, traducen
      ni crean trabajos derivados basados en los Servicios; ni copian (salvo para fines de archivo),
      arrendan, alquilan, distribuyen, vende, revenden, pignoran, ceden o transfieren, o gravan de
      otra forma los derechos en los Servicios o derechos relacionados con estos; (c) no usan ni
      acceden a los Servicios para desarrollar o prestar asistencia, o ayudar a un tercero a
      desarrollar o prestar asistencia a productos o servicios en competencia con los Servicios; ni
      (d) quitan ni cambian ningún aviso o etiqueta que haga alusión a la propiedad de los Servicios.
    </li>
    <li> Asimismo, el Cliente se asegurará de que su Administrador o sus Administradores, o Usuarios
      finales, de forma directa o indirecta: (a) no usan los Servicios para actividades en las que el
      uso o el fallo de los Servicios pueda dar lugar a daños físicos, lesiones personales o la
      muerte; (b) no usan los Servicios ni permiten usarlos para actividades ilegales, fraudulentas,
      ofensivas o dañinas; (c) no usan los Servicios de una manera que pueda dañar, deshabilitar,
      sobrecargar, alterar o interferir de otra forma en su aprovisionamiento, incluido el envío de
      virus o archivos dañados; y (d) no usan los Servicios para infringir los Derechos de propiedad
      intelectual o los derechos de propiedad de otros, ni para apropiarse indebidamente de ellos.
    </li>
    <li> El Cliente entiende que será responsables de cumplir cualquier normativa vertical o específica
      del sector que resulte aplicable, y que ni Sharp, ni el Distribuidor ni los Proveedores de
    servicios externos tendrán responsabilidad alguna si el Cliente no las cumple.</li>
    <li> El Cliente será el único responsable de obtener y mantener los equipos adecuados y los
      servicios auxiliares necesarios para conectarse o acceder a los Servicios, o para prestarlos o
      utilizarlos de cualquier otra forma, incluidos, entre otros, ordenadores, sistemas operativos y
      navegadores web, acceso a Internet, dispositivos móviles, dispositivos periféricos multifunción,
      sistemas de pantalla, y otros dispositivos electrónicos y accesorios (en conjunto, «Equipos»),
      El Cliente se asegurará de que los Equipos cumplen todas las configuraciones y especificaciones
      establecidas en la Documentación, si procede, correspondiente a los Servicios. La Documentación
      relacionada con los Servicios de software específicos puede resultar accesible a través de
    Servicios de software específicos.</li>
    <li> Si el Cliente tiene un contrato de suscripción en vigor con el Distribuidor o un Proveedor de
      servicios externo en relación con los Servicios o una parte de estos, el Cliente se asegurará de
      cumplir dicho contrato y de realizar los pagos de todas las cuotas aplicables. No hacerlo puede
      dar lugar a la suspensión o rescisión de la Cuenta del cliente o del acceso a los Servicios o el
    uso de estos, o a una parte de los mismos.</li>
    <li> Si el Cliente recibe una citación, un mandato judicial u otra solicitud válida en relación con
      los Servicios, una Cuenta del cliente o los Datos del cliente, el Cliente será responsable de
      responder a dichas solicitudes a través del acceso a sus propios Datos del cliente. Si el
      Cliente no fuera capaz de acceder a los Datos del cliente solicitados o a otra información
      solicitada, el Cliente se podrá en contacto con Sharp para recabar ayuda, y Sharp realizará los
      esfuerzos comercialmente razonables para ayudar al Cliente. Si el Cliente no responde con
      prontitud, Sharp podrá responder a la solicitud del tercero, pero no está obligado a hacerlo. Si
      Sharp, el Distribuidor o un Proveedor de servicios externo recibe una citación, un mandato
      judicial u otra solicitud válida en relación con los Servicios, una Cuenta del cliente o Datos
      del cliente, incluidas, entre otras cosas, Cuentas de administrador o cualquier dato de la
      Cuenta del cliente, Sharp, el Distribuidor o un Proveedor de servicios externo cumplirá la
      citación, el mandato judicial o la solicitud, según lo requiera la ley aplicable. En la <a
      tabindex="-1" class="text_underline" [href]="privacyUrl" target="_blank"><b>Política de
    privacidad de Synappx</b></a> se describe información adicional relacionada con el
  acceso de Sharp a las Cuentas del cliente o el uso de estas.</li>
  <li> El Cliente será responsable de cualquier infracción de este apartado por su parte, incluida
    cualquier infracción de su Administrador o sus Administradores, o de los Usuarios finales. El
    Cliente reconoce y entiende que Sharp, el Distribuidor y los Proveedores de servicios externos
    no tendrán ninguna responsabilidad con respecto al Cliente ni de otra forma por las acciones
  adoptadas por un Usuario final.</li>
</ol>
</div>
<div class="eula_points">
  <b>C. Función del administrador</b>
  <ol>
    <li> Los Administradores deben usar los Servicios de acuerdo con este Contrato, con las Condiciones
      adicionales, con la Documentación, si corresponde, con todas las obligaciones de empleo y
      condiciones y políticas del Cliente, así como con todas las leyes, reglamentos y normativas
    aplicables para el acceso a los Servicios o el uso de estos.</li>
    <li> El Administrador entiende que el Cliente puede asignar y reasignar las Cuentas de
    administrador.</li>
    <li> Un Administrador mantiene el control de la Cuenta del cliente mediante la gestión de dicha
      cuenta, incluidas las licencias (individuales o conjuntas) asociadas, a través del uso de la
    Cuenta de administrador de Synappx.</li>
    <li> El Administrador puede establecer, conceder acceso, supervisar, suspender y rescindir el acceso
      a todas las Cuentas de cliente, incluidas Cuentas de administrador adicionales, licencias de
    Espacio de trabajo y licencias de Usuarios finales.</li>
    <li> El Administrador o los Administradores también pueden ser Usuarios finales, en cuyo caso todas
      las condiciones de este Contrato, así como las Condiciones adicionales relacionadas con un
    Usuario se aplicarán al Administrador en su capacidad de Usuario final.</li>
  </ol>
</div>
<div class="eula_points">
  <b>D. Uso de los Usuarios finales</b>
  <ol>
    <li> El Cliente se asegurará de que los Usuarios finales usen los Servicios de acuerdo con este
      Contrato, con las Condiciones adicionales, con la Documentación, si corresponde, con todas las
      obligaciones de empleo y condiciones y políticas del Cliente, así como con todas las leyes,
    reglamentos y normativas aplicables para el acceso a los Servicios o el uso de estos.</li>
    <li> El Cliente es responsable del acceso de los Usuarios finales a los Servicios y del uso de
    estos.</li>
    <li> Un Usuario final no puede disociar su actividad en los Servicios de la del Cliente.</li>
    <li> El Cliente declara y garantiza: (a) que el Usuario final tiene todos los derechos y licencias
      necesarios para acceder a los Servicios y usarlos, y que (b) el almacenamiento, la transmisión y
      el tratamiento de cualquier información relacionada con el acceso del Usuario final a los
      Servicios no infringe las condiciones de este Contrato, las Condiciones adicionales, la
      Documentación pertinente, los Derechos de propiedad intelectual y los derechos de propiedad de
    otros, ni cualesquiera leyes, reglamentos o normativas aplicables.</li>
    <li> El Cliente reconoce que es el único responsable de la naturaleza, la calidad y la precisión de
    cualquier actividad de los Usuarios finales en conexión con los Servicios.</li>
  </ol>
</div>
<div class="eula_points">
  <b>E. Función del Distribuidor</b>
  <ol>
    <li> El Distribuidor es responsable de configurar una Cuenta del cliente y de proporcionar licencias
      para Servicios al Administrador o los Administradores. Cuando se crea un Administrador para el
    Cliente, el Distribuidor no tendrá ninguna capacidad para crear Cuentas de administrador.</li>
    <li> Los Distribuidores pueden gestionar licencias para las Cuentas del cliente, incluido comprar o
      dar de baja una licencia. Un Distribuidor no podrá dar de baja una licencia que ya se ha
      proporcionado a un Administrador a menos que se exprese de otra forma en el presente Contrato.
    </li>
    <li> Los Distribuidores tendrán acceso a información básica relacionada con las Cuentas del cliente,
      así como al nombre, la dirección, los números de teléfono del Cliente, y los nombres y
      direcciones de correo electrónico de todos los Administradores. Los Distribuidores también
    tendrán acceso y podrán ver todas las licencias de Cuentas del cliente para los Servicios.</li>
    <li> Los Distribuidores podrán suspender o cancelar el acceso de un Cliente a la Cuenta del cliente.
    </li>
    <li> Si el Distribuidor no puede o no cuenta con autorización para prestar servicio a una Cuenta del
      cliente, Sharp o su subsidiaria podrá transferir la Cuenta del cliente a otro Distribuidor a su
      entera discreción. Un Distribuidor no podrá transferir una Cuenta del cliente a otro
    Distribuidor por su cuenta.</li>
    <li>El Distribuidor puede usar los Servicios como el Usuarios final a solicitud del Cliente.</li>
  </ol>
</div>
<div class="eula_points"><b>F. Servicios</b>
<ol>
  <li> Los Clientes solo podrán acceder a los Servicios o usarlos de acuerdo con las condiciones de
    este Contrato, las Condiciones adicionales, la Documentación y cualquier condición adicional de
    uso o política de privacidad aplicable al acceso a los Servicios o al uso de estos. El
    incumplimiento por parte del Cliente del Contrato, las Condiciones adicionales, la Documentación
    y cualesquiera leyes, reglamentos o normativas puede dar lugar a la suspensión de la Cuenta del
  cliente o la Cuenta del administrador o a su rescisión a entera discreción de Sharp.</li>
  <li> Los Servicios o partes de estos pueden estar sujetos a contratos de suscripción con
    Distribuidores o Proveedores de servicios externos; el incumplimiento por parte de los Clientes
    de dichos contratos, incluido, entre otros, el pago de todas las cuotas aplicables, puede dar
    lugar a la suspensión o rescisión de la Cuenta del cliente o del acceso a los Servicios y el uso
  de estos, o una parte de estos, como resultado de dicho incumplimiento.</li>
  <li> El acceso a los Servicios y el uso de estos también está sujeto a la recepción por parte de
    Sharp de todas las cuotas del Distribuidor por el acceso a los Servicios y el uso de estos; si
    Sharp o su subsidiaria no reciben del Distribuidor una cuota aplicable a la Cuenta del cliente,
    y dicho incumplimiento de pago no se subsana en el plazo de treinta (30) días de su
    notificación, Sharp o su subsidiaria pueden, a su entera discreción, suspender o rescindir la
  Cuenta del cliente hasta que Sharp o su subsidiaria reciban los pagos adeudados.</li>
  <li> Sharp realizará los esfuerzos comerciales razonables para garantizar que todas las
    instalaciones usadas para almacenar y tratar los Datos del cliente cumplen estándares de
    seguridad comercialmente razonables. Mediante el uso de Servicios, el Cliente acepta la
    transferencia, el tratamiento y el almacenamiento de los Datos del cliente por parte de Sharp.
  </li>
  <li> El Cliente entiende que Sharp o los Proveedores de servicios externos pueden actualizar los
  Servicios periódicamente con o sin notificación al Cliente.</li>
  <li> Con independencia de cualquier disposición en sentido contrario, si se determina que los Datos
    del cliente infringen o pueden infringir este Contrato, o que alteran, sobrecargan, o pueden
    amenazar o dañar los Servicios de alguna forma, dichos Datos del cliente podrán eliminarse,
    total o parcialmente, a entera discreción de Sharp, con o sin notificación al Cliente y sin
    ninguna responsabilidad para Sharp. El Cliente será responsable de volcar en copias de seguridad
  los Datos del cliente en caso de que se produzca dicha eliminación.</li>
  <li> En la <a tabindex="-1" class="text_underline" [href]="privacyUrl" target="_blank"><b>Política
  de privacidad de Synappx</b></a> y la documentación aplicable correspondiente a los
  Servicios se pueden establecer condiciones adicionales relacionadas con la privacidad, el
  tratamiento y el almacenamiento de Datos del cliente, así como con el acceso a las Cuentas del
cliente.</li>
</ol>
</div>
<div class="eula_points"><b>G. Asistencia</b>
<ol>
  <li> El Cliente es responsable de ponerse en contacto con el Distribuidor para cualquier cuestión de
    asistencia relacionada con los Servicios que no pueda resolverse a través de la Documentación
  para Servicios de software específicos.</li>
  <li> A menos que Sharp o la sucursal de distribución de Sharp sea el Distribuidor para la Cuenta del
    cliente, Sharp no será responsable ante el Cliente con respecto a las cuestiones relacionadas
    con los Servicios o su asistencia más allá de lo que se indica en la Documentación para los
  Servicios de software específicos.</li>
</ol>
</div>
<div class="eula_points"><b>H. Propiedad intelectual</b>
<ol>
  <li> Este Contrato no otorga a Sharp, al Distribuidor ni a ningún Proveedor de servicios externos
    derecho alguno sobre los Datos del cliente ni sobre los derechos de propiedad intelectual
    asociados a una Cuenta del cliente o Cuenta de administrador, con excepción de los derechos
    limitados expresamente establecidos en este Contrato o en las Condiciones adicionales, o que
  sean de otra forma necesarios para prestar los Servicios y permitir al Cliente su uso.</li>
  <li> A menos que se especifique de otra forma en este Contrato o en las Condiciones adicionales, no
    se concede al Cliente, al Administrador o los Administradores ni a un Usuario final: (a) ningún
    Derecho de propiedad intelectual sobre los Servicios o con respecto a estos, ni a ninguna parte
    de los mismos; (b) ningún Derecho de propiedad intelectual sobre otras Cuentas del cliente o con
    respecto a estas; ni (c) ningún derecho a usar los logotipos, las marcas comerciales, las marcas
    de servicio, los nombres de dominio o las características de marca de Sharp, el Distribuidor,
  los Proveedores de servicios externos o cualquier componente de los Servicios.</li>
  <li> En la medida en que el Cliente, el Administrador o los Administradores, o un Usuario final
    solicite a Sharp determinadas acciones, incluidas, entre otras, transmitir, alojar o compartir
    archivos, o utilizar o conceder acceso a funciones de producto o ajustes, el Cliente concede a
    Sharp el permiso de realizar todas las acciones necesarias para que Sharp o el Distribuidor
    proporcione los Servicios y la funcionalidad disponible a través de los Servicios, y como se
    pueda especificar en la Documentación. Este permiso se extiende a todos los servicios de los
  Proveedores externos que Sharp utiliza para prestar los Servicios.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Exenciones de responsabilidad</b></div>
  <div class="eula_point_left">SHARP REALIZARÁ LOS ESFUERZOS COMERCIALMENTE RAZONABLES PARA QUE LOS
    CLIENTES PUEDAN ACCEDER A LOS SERVICIOS Y USARLOS DE ACUERDO CON ESTE CONTRATO, LAS CONDICIONES
    ADICIONALES Y CUALQUIER DOCUMENTACIÓN APLICABLE. CON INDEPENDENCIA DE CUALQUIER DISPOSICIÓN EN
    SENTIDO CONTRARIO, LOS SERVICIOS SE PROPORCIONAN «TAL CUAL». EN LA MEDIDA EN QUE LO PERMITA LA LEY Y
    SALVO QUE SE INDIQUE EXPRESAMENTE LO CONTRARIO EN EL PRESENTE DOCUMENTO, SHARP NO REALIZA NINGUNA
    DECLARACIÓN DE NINGÚN TIPO NI EN NOMBRE PROPIO, NI EN NOMBRE DEL DISTRIBUIDOR NI EN NOMBRE DE NINGÚN
    PROVEEDOR EXTERNO, YA SEA EXPRESA, IMPLÍCITA O DE OTRO TIPO, INCLUIDA CUALQUIER GARANTÍA DE QUE EL
    SERVICIO NO SE VERÁ INTERRUMPIDO, DE QUE ESTARÁ LIBRE DE ERRORES, DE QUE EL CONTENIDO ESTARÁ
    PROTEGIDO, O DE QUE NO SE PUEDA PERDER O RESULTAR DAÑADO DE OTRA FORMA, NI DE QUE LOS DEFECTOS SE
    CORREGIRÁN. SHARP TAMPOCO OFRECE NINGUNA GARANTÍAS DE COMERCIABILIDAD, ADECUACIÓN PARA UN FIN
    CONCRETO O INCUMPLIIENTO DE DERECHOS. SHARP NO REALIZA NINGUNA DECLARACIÓN SOBRE EL CONTENIDO,
    INCLUIDO CUALQUIER DATO DEL CLIENTE INTRODUCIDO O PROCEDENTE DE UNA CUENTA DEL CLIENTE, Y EL CLIENTE
    SERÁ EL ÚNICO RESPONSABLE DE SUS DATOS, ASÍ COMO DEL ACCESO A LOS SERVICIOS Y DEL USO DE ESTOS POR
  SU PARTE.</div>
</div>

<div class="eula_points"><b>J. Plazos y resolución</b>
<ol>
  <li> Este Contrato seguirá en vigor hasta que el Cliente deje de tener una suscripción válida o
    acceso a los Servicios, o hasta que este Contrato se resuelva de acuerdo con las condiciones
    aquí establecidas. El Cliente entiende que determinados Servicios de software específicos pueden
    rescindirse antes de acuerdo con las disposiciones de cualquier Condición adicional aplicable.
  </li>
  <li> El Distribuidor puede rescindir una Cuenta del cliente si el Cliente no paga una cuota de
  suscripción debida al Distribuidor por el acceso a los Servicios o por el uso de estos.</li>
  <li> Sharp puede rescindir este Contrato, así como el acceso a los Servicios y el uso de estos por
    parte del Usuario si Sharp no reciba las cuotas del Distribuidor por el acceso a los Servicios o
    el uso de estos por parte del Usuario, y dicho incumplimiento no se corrige en un plazo de
    treinta (30) días de su notificación por escrito; esta suspensión o rescisión pueden mantenerse
  en vigor hasta que Sharp reciba los pagos debidos.</li>
  <li> Este Contrato, así como el acceso a los Servicios y el uso de estos se renovarán
    automáticamente a menos que el Cliente notifique al Distribuidor su intención de rescindir los
  Servicios.</li>
  <li> Asimismo, Sharp o sus subsidiarias pueden rescindir este Contrato si el Cliente incumple
    cualquier condición sustancial de este Contrato y no pone remedio al incumplimiento en un plazo
    de treinta (30) días tras la recepción del aviso por escrito del incumplimiento; este aviso por
  escrito puede adoptar la forma de un correo electrónico u otra notificación electrónica.</li>
  <li> En el caso de resolución de este Contrato, los derechos concedidos al Cliente, al Administrador
    o a los Administradores y a los Usuarios finales se rescindirán inmediatamente. No obstante, la
    Cuenta del cliente y los Datos del cliente asociados a una Cuenta del cliente resultar
    accesibles durante quince (15) días tras la fecha de finalización efectiva de la suscripción. Al
    vencimiento o rescisión de este Contrato con independencia del motivo, salvo como se autorice
    expresamente en virtud de este apartado, el Cliente acepta dejar de acceder a los Servicios y de
    usarlos de inmediato. El Cliente reconoce y acepta que Sharp o los Proveedores de servicios
    externos no tendrán ninguna obligación de retener los Datos del cliente tras el periodo de
    treinta (30) días al que se hace referencia aquí y que, tras dicho periodo de treinta (30) días,
  todos los Datos del cliente se eliminarán completamente.</li>
  <li> Sin perjuicio de cualquier rescisión o vencimiento del presente Contrato, el Cliente seguirá
    siendo responsable de las cuotas que adeude al Distribuidor en virtud de su contrato con el
    Distribuidor o que pueda adeudar de cualquier otra forma al Distribuidor por cualquier acceso a
    los Servicios o uso de estos, antes de la fecha efectiva de rescisión o vencimiento de este
  Contrato.</li>
  <li> Los avisos al Cliente de arreglo con este apartado podrán adoptar la forma de un correo
    electrónico u otra notificación electrónica, y podrán dirigirse el Administrador o los
  Administradores.</li>
  <li> Los siguientes apartados de este Contrato seguirán en vigor tras el vencimiento o la rescisión
    de este Contrato con independencia del motivo: apartados F(6), H, I, J(6) a J(9), K, L, M, Q y
  S.</li>
  <li>El punto 1 al 9 de este Artículo J (Plazos y resolución) no son de aplicación a Synappx Manage.
    Synappx Manage puede
    resolver su uso libre en cualquier momento y por cualquier motivos a la entera discreción del
    Sharp, sin ninguna
  responsabilidad para el usuario.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Indemnización</b></div>
  <div class="eula_point_left">El Cliente indemnizará, defenderá y eximirá a Sharp, a sus Distribuidores,
    a los Proveedores de servicios externos y a cada una de sus empresas afiliadas, incluidas, entre
    otras, corporaciones matrices o subsidiarias, directores, ejecutivos, empleados, agentes y
    contratistas (en conjunto, «Partes de Sharp») de toda responsabilidad, daños y costes (incluidos
    gastos de liquidaciones y honorarios razonables de abogados), que puedan derivarse de una
    reclamación por parte de un tercero, en relación con: (a) el uso de los Servicios por parte del
    Cliente; (b) todos los Datos de del cliente; (c) cualquier incumplimiento de este Contrato por parte
    del Cliente, el Administrador o los Administradores, y el Usuario final; y (d) cualquier
    quebrantamiento, real o presunto, de leyes, reglamentos o normativas aplicables al Cliente, al
    Administrador o al Usuario final en relación con los Servicios. Sharp adoptará los pasos
    comercialmente razonables para notificar al Cliente cualquier reclamación o demanda con sujeción a
  este apartado.</div>
</div>

<div class="eula_point">
  <div><b>L. Limitación de responsabilidad</b></div>
  <div class="eula_point_left">HASTA EL MÁXIMO PERMITIDO POR LA LEY, LAS PARTES DE SHARP NO SERÁN
    RESPONSABLES ANTE EL CLIENTE, EL ADMINISTRADOR O LOS ADMINISTRADORES, LOS USUARIOS FINALES O
    CUALQUIER OTRA PARTE POR NINGÚN DAÑO DIRECTO, ESPECIAL, INCIDENTAL, INDIRECTO, PUNITIVO O
    CONSECUENTE, INCLUIDAS, ENTRE OTRAS, LAS PÉRDIDAS DE BENEFICIOS, DATOS, USO O CONTENIDO, O CUALQUIER
    OTRA PÉRDIDA RESULTANTE DE ESTE CONTRATO O EN RELACIÓN CON ESTE, CON LAS CONDICIONES ADICIONALES,
    CON LOS SERVICIOS, CON LA CUENTA DEL CLIENTE O CON LOS DATOS DEL CLIENTE. ESTE PÁRRAFO SE APLICARÁ
    CON INDEPENDENCIA DE SI LA TEORÍA DE RESPONSABILIDAD SE FUNDA EN UN CONTRATO, UN ACTO ILÍCITO, UNA
    NEGLIGENCIA, UN INCUMPLIENTO DE LA GARANTÍA, O UN RESPONSABILIDAD ESTRICTA O DE OTRO TIPO, Y CON
    INDEPEDENCIA DE SI LAS PARTES DE SHARP HAN SIDO AVISADAS DE LAS POSIBILIDADES DE DICHOS DAÑOS. EN
    NINGÚN CASO, LA RESPONSABILIDAD AGREGADA DE LAS PARTES DE SHARP CON RESPECTO AL CLIENTE O A
    CUALQUIER OTRA PARTE SUPERARÁ LA CANTIDAD CORRESPONDIENTE A TRES MESES DE CUOTAS POR LA PRESTACIÓN
    DE SERVICIOS. POR LA PRESENTE, EL USUARIO LIBERA A LAS PARTES DE SHARP DE TODAS LAS OBLIGACIONES,
    RESPONSABILIDADES Y RECLAMACIONES POR ENCIMA DE ESTE LÍMITE. ESTA LIMITACIÓN DE LA RESPONSABILIDAD
    PERMANECERÁN VIGENTES TRAS EL VENCIMIENTO O LA RESCISIÓN DE ESTE CONTRATO CON INDEPEDENCIA DEL
    MOTIVO, Y SE APLICARÁ INCLUSO SI SE DETERMINA QUE CUALQUIER ACCIÓN RESACITORIA ESPECIFICADA EN ESTA
  SECCIÓN HA FALLADO EN SU FINALIDAD ESENCIAL.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Legislación vigente/renuncia a un juicio con jurado</b></div>
  <div class="eula_point_left">Si el Cliente usa los Servicios para fines personales y no comerciales,
    este Contrato se regirá por las leyes de la
  jurisdicción en la que el Cliente compró u obtuvo la licencia para usar los Servicios.</div>
  <div class="eula_point_left">Si el Cliente no cumple este requisito, este Contrato de licencia se regirá
    e interpretará de acuerdo con las siguientes
  leyes sustantivas en vigor en:</div>
  <ol>
    <li>
      el Estado de Nueva York, si una licencia para usar el Servicio se compra u obtiene cuando el
      Cliente está en EE. UU.,
      Canadá o México;
    </li>
    <li>
      Inglaterra y Gales, si una licencia para usar el Servicio se compra u obtiene cuando el Cliente
      está en el Reino Unido o
      n cualquier país de la EEE;
    </li>
    <li>
      el país de la Unión Europea en el que se encuentre el Cliente, si el Cliente compra u obtiene
      una licencia para usar el
      Servicio en ese país de la Unión Europea;
    </li>
    <li>
      Japón, si una licencia para usar el Servicio se compra u obtiene cuando el Cliente está en
      cualquier jurisdicción no
      descrita anteriormente;
    </li>
  </ol>
  <div class="eula_point_left">Los tribunales competentes respectivos de:</div>
  <ol>
    <li>
      el condado de Nueva York, Nueva York cuando se apliquen las leyes de Nueva York;
    </li>
    <li>
      Inglaterra y Gales, cuando se aplique las leyes de Inglaterra y Gales;
    </li>
    <li>
      El país de la Unión Europea del Cliente, cuando se apliquen las leyes de dicho país de la Unión
      Europea;
    </li>
    <li>
      El tribunal del distrito de Osaka, cuando se apliquen las leyes japonesas
    </li>
    cada uno tendrán una jurisdicción no exclusiva sobre todas las disputas
    relacionadas con este Contrato.
  </ol>
  <div class="eula_point_left">
    Toda reclamación basada en este Contrato contra las Partes de Sharp deberá presentarse en el plazo
    de un (1) año de que
    se produzcan los hechos, o la reclamación o los hechos proscribirán. Por la presente, el Cliente y
    Sharp renuncian a
    dirimir cualquier disputa en relación con este Contrato o con los Servicios en un juicio con jurado.
  </div>
</div>

<div class="eula_point">
  <div><b>N. Marcas comerciales</b></div>
  <div class="eula_point_left">Las marcas comerciales o las marcas de servicio «SHARP», «Synappx»,
    «Synappx
    Meeting», «Synappx Go», o cualesquiera otros nombres de productos relacionados, nombres de servicios
    o
    logotipos utilizados, citados o a los que se haga referencia en los Servicios o a través de estos,
    son
    marcas comerciales o marcas de servicio de Sharp o sus filiales. El resto de productos, nombres de
    servicio, logotipos o nombres de empresa que aparezcan en los Servicios o a través de ellos son
    propiedad de sus respectivos titulares y pueden ser protegidos como sus marcas comerciales, marcas
  comerciales registradas, marcas de servicio o nombres comerciales.</div>
</div>

<div class="eula_point">
  <div><b>O. Fuerza mayor</b></div>
  <div class="eula_point_left">Ni las partes de Sharp, ni los Proveedores de servicios externos ni el
    Cliente
    serán responsables por el rendimiento inadecuado resultante de una condición que quede fuera del
    control
    razonable de dicha parte, incluidos, entre otros, desastres naturales, actos de guerra, actos de
    terrorismo u hostilidades, disturbios, acciones gubernamentales, situaciones laborables, o
    perturbaciones o averías eléctricas, de telecomunicaciones o de Internet. Sharp y el Cliente aceptan
    realizar los esfuerzos razonables para mitigar los efectos de cualquier evento de fuerza mayor.
  </div>
</div>

<div class="eula_point">
  <div><b>P. Exportación</b></div>
  <div class="eula_point_left">El Cliente acepta que las leyes de control de exportaciones locales (del
    país
    en el que se usen los Servicios) regirán el uso de los Servicios (incluidos los datos técnicos) y
    cualquier producto que se entregue al acceder a los Servicios o usarlos, y el Cliente acepta cumplir
    todas las leyes y normativas de exportación (incluidas las normativas de «transacciones asimiladas a
    exportaciones» y «transacciones asimiladas a reexportaciones»). El Cliente acepta que ningún dato,
    información, programa de software o materiales resultantes de los Servicios (o de un producto
    directo de
    estos) se exportará, directa o indirectamente, en contravención de dichas leyes ni que se utilizará
    para
    ningún producto prohibido por dichas leyes, incluida, entre otras, la proliferación de armas
    nucleares,
  químicas o biológicas o el desarrollo de tecnología para misiles.</div>
</div>

<div class="eula_point">
  <div><b>Q. Información estadística</b></div>
  <div class="eula_point_left">Sin perjuicio de ninguna disposición incluida en el presente Contrato o de
    otra
    forma, Sharp se reserva el derecho a supervisar el uso de los Servicios por parte del Cliente y a
    usar
    los Datos del cliente de manera agregada y anónima, a compilar información estadística, de uso y de
    rendimiento relacionada con el aprovisionamiento y el uso de los Servicios. También se reserva el
    derecho a hacer dicha información pública («Datos agregados»), siempre y cuando los Datos agregados
    no
    identifiquen al Cliente ni difundan los Datos del cliente. Sharp conserva todos los Derechos de
  propiedad intelectual sobre los citados Datos agregados.</div>
</div>

<div class="eula_points"><b>R. Modificación de las condiciones</b>
<ol>
  <li> Sharp puede revisar o modificar las condiciones de este Contrato de vez en cuando a su entera
    discreción. En el caso de que estas condiciones se revisen o modifiquen, el Administrador o los
    Administradores deberán aceptar las condiciones revisadas o modificadas en el primer inicio de
    sesión tras la fecha efectiva de la revisión o modificación. La versión actual de este Contrato
    se
    publicará en el <a tabindex="-1" class="text_underline" [href]="termsUseUrl"
    target="_blank">sitio
  de asistencia de Synappx</a> y el Cliente es responsable de consultar el sitio de manera
  periódica. Sharp realizará esfuerzos razonables para avisar de un cambio con treinta (30) de
  antelación a la fecha de entrada de vigor, aunque algunos cambios puede entrar en vigor con una
aviso de menos de treinta (30) días.</li>
<li> Si el Cliente continúa usando los Servicios tras la fecha de entrada en vigor del Contrato
  revisado
  o modificado, el Cliente aceptará que él, su Administrador o sus Administradores y sus Usuarios
  finales quedarán obligados a partir de ese momento por las nuevas condiciones. Si el Cliente no
  acepta las condiciones del Contrato revisado, el Cliente podrá optar por dejar de acceder a los
Servicios y de usarlos.</li>
</ol>
</div>
<div class="eula_points"><b>S. Condiciones adicionales</b>
<ol>
  <li> El Cliente acepta que entre él y Sharp no se establece ninguna asociación, empresa conjunto ni
  relación de agencia. </li>
  <li> A menos que el Cliente informe a Sharp de otra forma por escrito, Sharp puede incluir su nombre
    en
  una lista de clientes en los materiales de marketing de Sharp, incluidos los sitios web.</li>
  <li> Salvo que se especifique de otra forma en este Contrato, los avisos generales de Sharp
    dirigidos al
    Cliente o a los Usuarios finales en relación con este Contrato o con los Servicios se publicarán
    en
    el <a tabindex="-1" class="text_underline" [href]="supportType" target="_blank">sitio de
    asistencia
  de Synappx</a>. El Cliente y los Usuarios finales deberán, por tanto, visitar periódicamente
  el
  <a tabindex="-1" class="text_underline" [href]="supportType" target="_blank">sitio de asistencia
    de
  Synappx</a> para mantenerse al tanto de dichos avisos. Los avisos específicos en relación
  con
  los Servicios se dirigirán al correo electrónico registrado del Administrador. Cualquier aviso,
  incluidas notificaciones legales, preguntas o comentarios relacionados con este Contrato deberán
  dirigirse a: <br>
  <span>Synappx Product Manager</span>
  <div>Sharp Corporation </div>
  <div>492 Minosho-cho, Yamato-Koriyama City, </div>
  <div>Nara 639-1186, Japón</div>
</li>
<li> El Cliente no puede asignar ni transferir ninguna parte de este Contrato sin consentimiento
  previo
  por escrito de Sharp. Sharp puede asignar este Contrato mediante el envío de un aviso al
  Cliente,
  que puede adoptar la forma de un correo electrónico, una publicación o un mensaje a través de
  los
  Servicios. Con independencia de cualquier disposición en sentido contrario, Sharp puede ceder
  este
  Contrato a una entidad afiliada o en conexión con una fusión, adquisición o reorganización
  corporativa, o una venta del conjunto o una parte sustancial de sus activos sin previo aviso al
Cliente.</li>
<li> La renuncia de Sharp a un incumplimiento o derecho en virtud de este Contrato no se considerará
  una
renuncia a otros incumplimientos o derechos posteriores.</li>
<li> Si una disposición de este Contrato (o una parte de ella) se considerara de difícil aplicación
  o
  contraria a la ley, dicha disposición se modificará en la medida estricta necesaria para
  permitir su
aplicación, y el resto de las partes de este Contrato seguirán en plena vigencia.</li>
<li> Este Contrato y las Condiciones adicionales, si las hubiera, constituyen el acuerdo completo
  entre
  el Cliente y Sharp con respecto a los Servicios, y anulan y sustituyen cualquier entendimiento o
  Contratos anteriores o contemporáneos, incluidos pedidos de compra, ya sean por escrito u
  orales, con
respeto al asunto principal de este Contrato.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
